import AuthConstants from '../constants/Auth';

const LocalStorage = {
  user: () => (JSON.parse(localStorage.getItem(AuthConstants.userKey) ?? '')),
  token: () => (localStorage.getItem(AuthConstants.tokenKey)),
  setUser: (data : any) => (localStorage.setItem(AuthConstants.userKey, data)),
  setToken: (data: string) => (localStorage.setItem(AuthConstants.tokenKey, data)),
  clearToken: () => localStorage.removeItem(AuthConstants.tokenKey),
  clearUser: () => localStorage.removeItem(AuthConstants.userKey),

  selectedCompany: () => {
    const data = localStorage.getItem(AuthConstants.selectedCompanyKey);
    if (!data) return null;
    try { return JSON.parse(data); } catch { return null; }
  },
  setSelectedCompany: (data: any) => localStorage.setItem(AuthConstants.selectedCompanyKey, JSON.stringify(data)),
  clearSelectedCompany: () => localStorage.removeItem(AuthConstants.selectedCompanyKey),
};

export default LocalStorage;
